/** Pre-filled WhatsApp links for flight quote admin (free — no API). */

export const normalizeWhatsAppPhone = (phone) => {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('92')) return digits;
  if (digits.startsWith('0')) return `92${digits.slice(1)}`;
  return digits;
};

export const whatsAppLink = (phone, text) => {
  const normalized = normalizeWhatsAppPhone(phone);
  if (!normalized) return null;
  const base = `https://wa.me/${normalized}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const buildPriceConfirmedWhatsApp = (row, updateForm) => {
  const confirmed = updateForm.confirmedAmount
    ? `${updateForm.confirmedCurrency} ${updateForm.confirmedAmount}`
    : `${row.shownCurrency} ${row.shownAmount}`;
  const trackUrl = `https://rehmantravels.aaqsols.com/v2/flights/track?requestId=${row.requestId}`;

  return `Assalam o Alaikum ${row.customerName}! Your flight fare is *confirmed* ✈️

*${row.origin} → ${row.destination}* · ${row.departureDate}
${row.airlineName} ${row.flightNumber}

*Confirmed price: ${confirmed}*

${updateForm.agentMessage || 'Please reply to proceed with payment. Our team will book on the IATA portal.'}

Track: ${trackUrl}
PIN: ${row.trackingPin || '—'}

— Rehman Travels`;
};

export const buildFollowUpWhatsApp = (row) => {
  return `Assalam o Alaikum ${row.customerName}, this is Rehman Travels regarding your flight request (${row.origin} → ${row.destination}, ${row.departureDate}). We are confirming the live fare on the IATA portal and will update you shortly. Request ID: ${row.requestId}`;
};
